import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgxImageCompressService } from 'ngx-image-compress';
import { Observable } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from 'src/app/services/notification.service';
import * as Bowser from "bowser";

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent {
  // File Model (Imagen)
  @Input() model: any;
  // Image Title
  @Input() title: string;
  // Background to show before the picture is taken
  @Input() defaultBackground: string;
  @Input() horizontalOnly: boolean;
// device taken
  @Input() isDesktop: boolean;
  // Picture url to use as picture preview
  url: string | ArrayBuffer;

  localUrl: any;

  browser : any;

  fileCompresed : File;

  // Ouput function to execute after the picture is taken
  @Output() takePicture = new EventEmitter<any>();

  constructor(private ngxService: NgxUiLoaderService, private notifyService : NotificationService, private imageCompress: NgxImageCompressService) { }

  _takePicture($event) {
    this.model = $event.target.files[0];
    let file =  this.model as File;
    //this.notifyService.showInfo("Size Picture " + file.size, "INFO")
    //if(file.size > 1000){
      //this.ngxService.start();
      this.notifyService.showInfo("Procesando Captura", "INFO");
      this.ngxService.start();

      this.validatePicture(this.model).subscribe(validated => {
        this.compress(validated).subscribe (response => {
          //this.notifyService.showInfo("After Compress " + file.size, "INFO")
          //Code block after completing each compression
            this.model = response;
            this.notifyService.showSuccess("Captura Procesada", "INFO")
            this.fileCompresed = response as File;
            //this.notifyService.showInfo("Size Picture Compress " + this.fileCompresed.size, "INFO")
            this._showPreview();
            this.ngxService.stop();
            this.takePicture.emit(this.model);
          });
      })
      
    //}else{
    //  this._showPreview();
     //     this.takePicture.emit(this.model);
    //}
  }

  private _showPreview() {
    var reader = new FileReader();
    
		reader.readAsDataURL(this.model);

		reader.onload = (_event) => {
      this.url = reader.result;
      this.takePicture.emit(this.url);
		}
  }

  compress(file: File): Observable<any> {
    const width = 1400; // For scaling relative to width
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return Observable.create(observer => {
      reader.onload = ev => {
        const img = new Image();
        img.src = (ev.target as any).result;
        (img.onload = () => {
          const canvas = document.createElement('canvas'); // Use Angular's Renderer2 method
          
          const scaleFactor = width / img.width;
          canvas.width = width;
          canvas.height = img.height * scaleFactor;
          
          const ctx = <CanvasRenderingContext2D> canvas.getContext('2d');
          ctx.save();
          this.browser = Bowser.getParser(window.navigator.userAgent);
          
          if(this.browser.getBrowser().name == 'Safari' ){
            //ctx.setTransform(scaleFactor, 0, 0, scaleFactor, elem.width / 2, elem.height / 2); // sets scale and origin
            //ctx.rotate(- Math.PI / 2);
            //ctx.drawImage(img, -img.width / 2, -img.height / 2);
            //ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
            //ctx.drawImage(img, 0, 0, -width / 2, -img.height * scaleFactor);
            ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          } else {
            ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          }
            
          ctx.restore();
          ctx.canvas.toBlob(
            blob => {
              observer.next(
                new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                }),
              );
            },
            'image/jpeg',
            1,
          );
          
        }),
          (reader.onerror = error => observer.error(error));
      };
    });
  }

  validatePicture(file: File): Observable<any> {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    return Observable.create(observer => {
      reader.onload = ev => {
        const img = new Image();
        img.src = (ev.target as any).result;
        (img.onload = () => {
          const canvas = document.createElement('canvas'); // Use Angular's Renderer2 method
          
          if (this.horizontalOnly && img.height > img.width) {
            canvas.width = img.height;
            canvas.height = img.width;

            const ctx = <CanvasRenderingContext2D> canvas.getContext('2d');

            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-90 * Math.PI / 180);

            ctx.save();
            ctx.drawImage(img, img.width / -2, img.height / -2);
            ctx.restore();

            ctx.canvas.toBlob(
              blob => {
                observer.next(
                  new File([blob], file.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  }),
                );
              },
              'image/jpeg',
              1,
            );
          } else {
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = <CanvasRenderingContext2D> canvas.getContext('2d');
            ctx.save();
          
            this.browser = Bowser.getParser(window.navigator.userAgent);
            ctx.drawImage(img, 0, 0, img.width, img.height);
              
            ctx.restore();
            ctx.canvas.toBlob(
              blob => {
                observer.next(
                  new File([blob], file.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  }),
                );
              },
              'image/jpeg',
              1,
            );
          }
        }),
          (reader.onerror = error => observer.error(error));
      };
    });
  }
}
